export enum EncoreEcosystemDependency {
  OTHER_PROVISIONING_SERVICES = 'Other provisioning services - Animal-based energy',
  BIOMASS_PROVISIONING = 'Biomass provisioning',
  SOLID_WASTE_REMEDIATION = 'Solid waste remediation',
  SOIL_AND_SEDIMENT_RETENTION = 'Soil and sediment retention',
  WATER_PURIFICATION = 'Water purification',
  SOIL_QUALITY_REGULATION = 'Soil quality regulation',
  OTHER_REGULATING_AND_MAINTENANCE_SERVICE_DILUTION_BY_ATMOSPHERE_AND_ECOSYSTEMS = 'Other regulating and maintenance service - Dilution by atmosphere and ecosystems',
  BIOLOGICAL_CONTROL = 'Biological control',
  AIR_FILTRATION = 'Air Filtration',
  FLOOD_MITIGATION_SERVICES = 'Flood mitigation services',
  GENETIC_MATERIAL = 'Genetic material',
  GLOBAL_CLIMATE_REGULATION = 'Global climate regulation',
  WATER_SUPPLY = 'Water supply',
  NURSERY_POPULATION_AND_HABITAT_MAINTENANCE = 'Nursery population and habitat maintenance',
  NOISE_ATTENUATION = 'Noise attenuation',
  OTHER_REGULATING_AND_MAINTENANCE_SERVICE_MEDIATION_OF_SENSORY_IMPACTS = 'Other regulating and maintenance service - Mediation of sensory impacts (other than noise)',
  LOCAL_MICRO_AND_MESO_CLIMATE_REGULATION = 'Local (micro and meso) climate regulation',
  POLLINATION = 'Pollination',
  STORM_MITIGATION = 'Storm mitigation',
  WATER_FLOW_REGULATION = 'Water flow regulation',
  RAINFALL_PATTERN_REGULATION = 'Rainfall pattern regulation',
  RECREATION_RELATED_SERVICES = 'Recreation related services',
  VISUAL_AMENITY_SERVICES = 'Visual amenity services',
  EDUCATION_SCIENTIFIC_AND_RESEARCH_SERVICES = 'Education, scientific and research services',
  SPIRITUAL_ARTISTIC_AND_SYMBOLIC_SERVICES = 'Spiritual, artistic and symbolic services',
}

export enum EncoreImpactDriver {
  DISTURBANCES = 'Disturbances (e.g noise, light)',
  AREA_OF_FRESHWATER_USE = 'Area of freshwater use',
  EMISSIONS_OF_GHG = 'Emissions of GHG',
  AREA_OF_SEABED_USE = 'Area of seabed use',
  EMISSIONS_OF_NON_GHG_AIR_POLLUTANTS = 'Emissions of non-GHG air pollutants',
  OTHER_BIOTIC_RESOURCE_EXTRACTION = 'Other biotic resource extraction (e.g. fish, timber)',
  OTHER_ABIOTIC_RESOURCE_EXTRACTION = 'Other abiotic resource extraction',
  EMISSIONS_OF_TOXIC_SOIL_AND_WATER_POLLUTANTS = 'Emissions of toxic soil and water pollutants',
  EMISSIONS_OF_NUTRIENT_SOIL_AND_WATER_POLLUTANTS = 'Emissions of nutrient soil and water pollutants',
  GENERATION_AND_RELEASE_OF_SOLID_WASTE = 'Generation and release of solid waste',
  AREA_OF_LAND_USE = 'Area of land use',
  VOLUME_OF_WATER_USE = 'Volume of water use',
  INTRODUCTION_OF_INVASIVE_SPECIES = 'Introduction of invasive species',
}

export enum ComplianceFramework {
  GLOBAL_BIODIVERSITY_FRAMEWORK = 'Global Biodiversity Framework',
  SUSTAINABLE_DEVELOPMENT_GOALS = 'Sustainable Development Goals',
}

type IndustrialActivity = {
  id: string;
  unique_code: string;
  section: string;
  division: string;
  group: string;
  activity: string;
};

type ActivityDependency = {
  activity: IndustrialActivity;
  dependency: EncoreEcosystemDependency;
};

type ActivityImpact = {
  activity: IndustrialActivity;
  impact: EncoreImpactDriver;
};

type ComplianceTarget = {
  framework: ComplianceFramework;
  unique_code: string;
  title?: string;
  description?: string;
};

export type ActivityDependencyScore = {
  activity_dependency: ActivityDependency;
  value?: number;
  compliance_targets?: ComplianceTarget[];
};

export type ActivityImpactScore = {
  activity_impact: ActivityImpact;
  value?: number;
  compliance_targets?: ComplianceTarget[];
};

/**
 * GET /api/v1/organization/{organization_id}/industrial-activity/dependencies
 */
export const GET_ORGANIZATION_INDUSTRIAL_ACTIVITY_DEPENDENCIES_PATH =
  'organization/{organization_id}/industrial-activity/dependencies';
export type GetOrganizationIndustrialActivityDependenciesRequestPathVariables = { organization_id: string };
export type GetOrganizationIndustrialActivityDependenciesSuccessDto = ActivityDependencyScore[];
export type GetOrganizationIndustrialActivityDependenciesErrorDto = Error;

/**
 * GET /api/v1/organization/{organization_id}/industrial-activity/impacts
 */
export const GET_ORGANIZATION_INDUSTRIAL_ACTIVITY_IMPACTS_PATH =
  'organization/{organization_id}/industrial-activity/impacts';
export type GetOrganizationIndustrialActivityImpactsRequestPathVariables = { organization_id: string };
export type GetOrganizationIndustrialActivityImpactsSuccessDto = ActivityImpactScore[];
export type GetOrganizationIndustrialActivityImpactsErrorDto = Error;
